export const ICONS_MAP = {
  apps: 'icons-menu/apps.svg', // Маршрут до иконки указывать только с одним ближайшим родителем во вложенности
  reports: 'icons-menu/reports.svg',
  analytics: 'icons-menu/analytics.svg',
  etlSetup: 'icons-menu/etlSetup.svg',
  objects: 'icons-menu/objects.svg',
  configurations: 'icons-menu/configurations.svg',
  devices: 'icons-menu/devices.svg',
  media: 'icons-menu/media.svg',
  refBooks: 'icons-menu/refBooks.svg',
  logFiles: 'icons-menu/logFiles.svg',
  systemAccess: 'icons-menu/systemAccess.svg',
  extSystems: 'icons-menu/extSystems.svg',
  server: 'icons-menu/server.svg',
  mainStore: 'icons-menu/mainStore.svg',
  userSettings: 'icons-menu/userSettings.svg',
  link: 'icons-menu/link.svg',
  bars: 'icons-menu/bars.svg',
  favorite: 'assets/images/icons-dashboard/favorite.svg',
  tachometer: 'assets/images/icons-dashboard/tachometer.svg',
  questionCircle: './questionCircle.svg',
  questionCircleApp: 'assets/images/questionCircle.svg',
  refresh: 'icons-eventslog/refresh.svg',
  success: './success.svg',
  download: './download.svg',
  filter: './filter.svg',
  pause: 'icons-eventslog/pause.svg',
  play: 'icons-eventslog/play.svg',
  closeAll: './closeAll.svg',
  openAll: './openAll.svg',
  filtersV2: './filtersV2.svg',
  list: 'assets/images/list.svg',
  listIcon: './list.svg',
  reportsBlock: 'assets/images/icons-reports/block.svg',
  add: './add.svg',
  addApp: 'assets/images/add.svg',
  delete: './delete.svg',
  deleteApp: 'assets/images/delete.svg',
  edit: './edit.svg',
  addFolder: './addFolder.svg',
  copy: './copy.svg',
  infoGray: './infoGray.svg',
  settings: './settings.svg',
  pencil: './pencil.svg',
  operatingMode: './operatingMode.svg',
  schedule: './schedule.svg',
  star: './star.svg',
  bells: './bells.svg',
  bellsSlash: './bellsSlash.svg',
  caret: './caret.svg',
  starFilled: './starFilled.svg',
  pin: 'assets/images/pin.svg',
  pinFilled: 'assets/images/pinFilled.svg',
  folder: './folder.svg',
  openFolder: './openFolder.svg',
  contextMenu: './contextMenu.svg',
  closeGhost: './closeGhost.svg',
  phone: './phone.svg',
  phoneSlash: './phoneSlash.svg',
  upload: './upload.svg',
  linkIcon: './linkIcon.svg',
  clockIcon: './clockIcon.svg',
  eye: './eye.svg',
  eyeSlash: './eyeSlash.svg',
  linkContour: './linkContour.svg',
  share: './share.svg',
  unlink: './unlink.svg',
  group: './group.svg',
  tree: './tree.svg',
  calendar: './calendar.svg',
};

export type IconName = keyof typeof ICONS_MAP;
